<div>
  <div class="modal-header">
    <h3>Add Attachment</h3>
  </div>
  <div class="modal-body">
    <div class="row" style="margin: unset; border: solid lightgrey 1px;" id="dropTarget">
      <div class="col-md-12" style="padding: 10px;">
        <form style="display: flex; justify-content: center; align-items: center;">
          <div style="margin-right: 10px;">Drop File(s) here or</div>
          <button type="button" class="btn btn-primary" id="file_button">
            Select File(s)
          </button>

        </form>
      </div>
    </div>
    <div class="row" *ngFor="let f of files | keyvalue">
      <div class="col-md-12">{{f.value.filename}}</div>
      <ngb-progressbar class="col-md-12" style="margin: 15px 0 4px;" *ngIf="f.value.progress > 0"
                       type="info" [striped]="true"
                       [value]="f.value.progress"></ngb-progressbar>

    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-default" (click)="cancel()" *ngIf="!saving">Cancel</button>
    <button class="btn btn-primary" (click)="submit()" *ngIf="!saving">Submit</button>
    <button class="btn btn-primary" *ngIf="saving"><i class="fa fa-spinner fa-pulse"></i></button>
  </div>
</div>
